<template>
  <div :id="componentId" class="sp1-box_1 flex-row justify-end" :style="boxStyle">
    <a
      v-if="currentItem.jumpType === 1"
      class="sp1-image-link"
      href="javascript:;"
      @click.prevent="goArticle(currentItem.linkAddress)"
    >
      <img
        class="sp1-image_3 link-image"
        referrerpolicy="no-referrer"
        :src="currentItem.imageUrl"
      />
    </a>
    <a
      v-else-if="currentItem.jumpType === 2"
      class="sp1-image-link"
      :href="currentItem.linkAddress"
      target="_blank"
    >
      <img
        class="sp1-image_3 link-image"
        referrerpolicy="no-referrer"
        :src="currentItem.imageUrl"
      />
    </a>
    <div v-else class="sp1-image-link sp1-image-static">
      <img
        class="sp1-image_3"
        referrerpolicy="no-referrer"
        :src="currentItem.imageUrl"
      />
    </div>
    <div class="sp1-box_114 flex-col">
      <div class="sp1-text-group_41 flex-col justify-between">
        <a
          v-if="currentItem.jumpType === 1"
          class="sp1-text_1 link-title"
          href="javascript:;"
          @click.prevent="goArticle(currentItem.linkAddress)"
        >
          {{ currentItem.articleTitle }}
        </a>
        <a
          v-else-if="currentItem.jumpType === 2"
          class="sp1-text_1 link-title"
          :href="currentItem.linkAddress"
          target="_blank"
        >
          {{ currentItem.articleTitle }}
        </a>
        <span v-else class="sp1-text_1">{{ currentItem.articleTitle }}</span>
        <span class="sp1-text_2">{{ currentItem.subtitle }}</span>
      </div>
      <span class="sp1-text_3">
        {{ currentItem.articleSummary }}
      </span>
      <div class="sp1-box_115 flex-row">
        <div class="sp1-image-text_33 flex-row justify-between">
          <ShareButton :news-code="currentItem.newsCode" :title="currentItem.articleTitle" />
        </div>
        <div class="sp1-image-text_34 flex-row justify-between">
          <FavoriteButton :news-code="currentItem.articleNumber" />
        </div>
        <img
          class="sp1-thumbnail_3 arrow-left"
          referrerpolicy="no-referrer"
          src="../assets/img/FigmaDDSSlicePNG4403a6453e6aece7d98dc93e0b220b55.png"
          @click="prevItem"
        />
        <div class="sp1-text-wrapper_1">
          <span class="sp1-text_4">{{ itemIndex + 1 }}</span>
          <span class="sp1-text_5">/&nbsp;{{ items.length }}</span>
        </div>
        <img
          class="sp1-thumbnail_4 arrow-right"
          referrerpolicy="no-referrer"
          src="../assets/img/FigmaDDSSlicePNG7434b7aab0dd9e85368000e91a7d5b90.png"
          @click="nextItem"
        />
      </div>
    </div>
    <div class="sp1-section_2 flex-col"></div>
  </div>
</template>

<script>
import FavoriteButton from '../../../channel/components/FavoriteButton.vue'
import ShareButton from '../../../channel/components/ShareButton.vue'

export default {
  name: 'HeroCarouselPanel',
  components: {
    FavoriteButton,
    ShareButton
  },
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_3'
    }
  },
  data() {
    return {
      itemIndex: 0,
      items: [
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.png'),
          articleNumber: 1,
          newsCode: '19299356',
          articleTitle: '第七届中国品牌发展论坛系列活动现场花絮!',
          subtitle: '浙江大学CARD中国农业品牌研究中心主任胡晓云',
          articleSummary: '创造品牌经济有三大特征：第一个特征是提升实体经济价值的符号经济。第二是增加资源经济价值的关系经济。第三是以产品与符号的意义为价值的价值经济。在我国，品牌建设要体现"第二次现代化"的重要特征。',
          jumpType: 1,
          linkAddress: '/zp/a/19299356'
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.png'),
          articleNumber: 2,
          newsCode: '19299357',
          articleTitle: '区域农业品牌发展论坛在京成功举办',
          subtitle: '《中国品牌》杂志社社长张超',
          articleSummary: '本次活动聚焦区域农业品牌高质量发展，邀请业内专家、地方政府代表及企业代表共同探讨品牌建设新路径，助力乡村振兴战略深入实施。',
          jumpType: 2,
          linkAddress: 'https://www.example.com/article/2'
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.png'),
          articleNumber: 3,
          newsCode: '19299358',
          articleTitle: '2025区域农业品牌年度盛典即将启幕',
          subtitle: '中国品牌网',
          articleSummary: '年度盛典将汇聚全国优质区域农业品牌，展示品牌建设成果，搭建交流合作平台，推动农业品牌化发展迈向新台阶。',
          jumpType: 1,
          linkAddress: '/zp/a/19299356'
        }
      ],
      backgroundColor: 'rgba(255, 255, 255, 1)'
    };
  },
  computed: {
    currentItem() {
      return this.items[this.itemIndex] || this.items[0];
    },
    boxStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
         padding: '20px 300px',
        boxSizing: 'border-box'
      };
    }
  },
  methods: {
    prevItem() {
      this.itemIndex = (this.itemIndex - 1 + this.items.length) % this.items.length;
    },
    nextItem() {
      this.itemIndex = (this.itemIndex + 1) % this.items.length;
    },
    goArticle(path) {
      if (!path) return;
      if (path.startsWith('http')) {
        window.open(path, '_blank');
        return;
      }
      window.open(path, '_blank');
    }
  }
};
</script>

<style scoped>
.sp1-box_1 {
  width: 2000px;
  margin-left: -300px;
  padding: 20px 300px;
  box-sizing: border-box;
}

.sp1-image-link {
  display: block;
}

.sp1-image-static {
  cursor: default;
}

.link-title {
  cursor: pointer;
  transition: color 0.2s;
}

.link-title:hover {
  color: #A00000;
  text-decoration: underline;
}

.link-image {
  cursor: pointer;
  transition: opacity 0.2s;
}

.link-image:hover {
  opacity: 0.85;
}

.arrow-left,
.arrow-right {
  cursor: pointer;
  transition: opacity 0.2s;
}

.arrow-left:hover,
.arrow-right:hover {
  opacity: 0.7;
}

.sp1-image-text_33,
.sp1-image-text_34 {
  width: auto;
  min-width: 60px;
  overflow: visible;
}

.sp1-image-text_33 {
  margin-right: 16px;
}

.sp1-image-text_34 {
  margin-left: 0;
}
</style>
